import React from "react";
import {Box, Button, Container, Paper, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" sx={{py: 6}}>
            <Paper sx={{p: 4, borderRadius: 3}}>
                <Stack spacing={2.5}>
                    <Box>
                        <Typography variant="h4" fontWeight={900}>
                            Page introuvable
                        </Typography>
                        <Typography variant="body2" sx={{opacity: 0.8}}>
                            L’adresse demandée n’existe pas (ou a été déplacée).
                        </Typography>
                    </Box>

                    <Stack direction={{xs: "column", sm: "row"}} spacing={1.5} useFlexGap>
                        <Button variant="contained" onClick={() => navigate("/")}>
                            Retour à l’accueil
                        </Button>
                        <Button variant="outlined" color="inherit" onClick={() => navigate("/admin")}>
                            Aller au pilotage
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Container>
    );
};

export default NotFound;
